
import { Map, Record } from 'immutable';

export interface NavigationState extends Map<string, any> {

  navigationList: any;
  updateNavigationList: any;
  navigationListLoaded: boolean;
  navigationListFailed: boolean;
  navigationListLoading: boolean;
  navigationListUpdateLoading: boolean,
  navigationListUpdateLoaded: boolean,
  navigationListUpdateFailed: boolean,
}

export const NavigationRecordState = Record({
  navigationList: {},
  updateNavigationList: {},
  navigationListLoaded: false,
  navigationListFailed: false,
  navigationListLoading: false,
  navigationListUpdateLoading: false,
  navigationListUpdateLoaded: false,
  navigationListUpdateFailed: false,
});
